/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import Popup from '@scandipwa/scandipwa/src/component/Popup';
import { ProductType } from '@scandipwa/scandipwa/src/type/ProductList.type';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import ProductTabs from 'Component/ProductTabs';
import { McTechSpecsType } from 'Type/McTechSpecs';

/** @namespace Pwa/Component/ProductElementsTabs/Templates/Tavoli/Component */
export class TavoliComponent extends PureComponent {
    static propTypes = {
        mcTechSpecs: McTechSpecsType.isRequired,
        showEntityPopup: PropTypes.func.isRequired,
        product: ProductType.isRequired,
    };

    state = {
        expanded: false,
        activeSlide: 0,
    };

    showMore = () => {
        this.setState((prevState) => ({ expanded: !prevState.expanded }));
    };

    changeActiveSlide = (idx) => {
        this.setState({ activeSlide: idx });
    };

    entityDescription = (entityType) => {
        const {
            product: {
                desc_finiture_colori,
                desc_complementi,
                desc_versioni_prodotto,
            },
        } = this.props;

        switch (entityType) {
        case 'finiture_e_colori':
            return desc_finiture_colori;
        case 'complementi':
            return desc_complementi;
        case 'versioni_prodotto':
            return desc_versioni_prodotto;

        default:
            return null;
        }
    };

    renderEntityTabGrid(entities, initialItemsToShow, entityType) {
        const {
            product: {
                sku,
            },
            showEntityPopup,
        } = this.props;

        const itemsToShow = this.state.expanded ? entities.length : initialItemsToShow;
        const buttonText = this.state.expanded ? __('Show less entity') : __('Show more entity');
        const basePath = `media/catalog/images/${sku}/${entityType}`;

        return (
            <div id="instructions" className="single_tab">
                { this.entityDescription(entityType) && (
                    <p className="mb-5">
                        { parse(this.entityDescription(entityType)) }
                    </p>
                ) }
                <div className={ `entity_tab_grid ${entityType}` }>
                    { /* Rimuovo gli eventuali valori duplicati */ }
                    { entities.filter((value, index, self) => index === self.findIndex((t) => (
                        t.code === value.code
                    ))).slice(0, itemsToShow).map((item, idx) => (
                        <button
                          onClick={ () => {
                              showEntityPopup(`SLIDER_${ entityType }`);
                              this.changeActiveSlide(idx);
                          } }
                          className="single_entity"
                        >
                            <img
                              src={ item.image ? item.image : `${basePath}/${item.code}.jpg` }
                              alt="Immagine tab"
                            />
                            <h2>{ item.label }</h2>
                        </button>
                    )) }
                    <Popup
                      id={ `ENTITY_POPUP_SLIDER_${ entityType }` }
                    >
                        <div className="entity_popup slider_popup">
                            <Swiper
                              navigation
                              watchOverflow
                              initialSlide={ this.state.activeSlide }
                            >
                                { entities.filter((value, index, self) => index === self.findIndex((t) => (
                                    t.code === value.code
                                ))).slice(0, itemsToShow).map((item, idx) => (
                                    <SwiperSlide key={ idx }>
                                        <img
                                          src={ item.image ? item.image : `${basePath}/${item.code}.jpg` }
                                          alt="Immagine tab"
                                        />
                                        <p className="label">{ item.label }</p>
                                    </SwiperSlide>
                                )) }
                            </Swiper>
                        </div>
                    </Popup>
                </div>
                { entities.length > initialItemsToShow && (
                    <button className="Button mostra_di_piu" onClick={ this.showMore }>
                        { buttonText }
                    </button>
                ) }
            </div>
        );
    }

    renderEntityTabGridLink(entities, initialItemsToShow, entityType) {
        const itemsToShow = this.state.expanded ? entities.length : initialItemsToShow;
        const buttonText = this.state.expanded ? __('Show less entity') : __('Show more entity');

        return (
            <div id="instructions" className="single_tab">
                { this.entityDescription(entityType) && (
                    <p className="mb-5">
                        { parse(this.entityDescription(entityType)) }
                    </p>
                ) }
                <div className={ `entity_tab_grid ${entityType}` }>
                    { /* Rimuovo gli eventuali valori duplicati */ }
                    { entities.slice(0, itemsToShow).map((item) => (
                        item.link ? (
                            <a
                              href={ item.link }
                              className="single_entity"
                            >
                                <img
                                  src={ item.image }
                                  alt="Immagine tab"
                                />
                                <h3 className="single_complements">{ item.label }</h3>
                            </a>
                        ) : (
                            <div className="single_entity">
                                <img
                                  src={ item.image }
                                  alt="Immagine tab"
                                />
                                <h3>{ item.label }</h3>
                            </div>
                        )
                    )) }
                </div>
                { entities.length > initialItemsToShow && (
                    <button className="Button mostra_di_piu" onClick={ this.showMore }>
                        { buttonText }
                    </button>
                ) }
            </div>
        );
    }

    renderMeasures() {
        const {
            mcTechSpecs: {
                mc_dimension_width, mc_dimension_depth, mc_dimension_height, mca_p_aperto, mc_measure_image,
                mca_l_letto_utile, mca_p_letto_utile,
            },
        } = this.props;

        return (
            <div className="misure_prodotto">
                <h3>{ __('Product measurements') }</h3>
                <div>
                    <dl>
                        { mc_dimension_width && mc_dimension_depth && mc_dimension_height
                        && (
                            <dd>
                                { `${mc_dimension_width} x ${mc_dimension_depth} x ${mc_dimension_height}cm` }
                                <span className="mcTechspecs-Sectiontitle">{ __(' (width, depth, height)') }</span>
                            </dd>
                        ) }

                        { mca_l_letto_utile && mca_p_letto_utile
                        && (mca_l_letto_utile !== '0' && mca_p_letto_utile !== '0')
                        && (
                            <>
                            <dt>{ __('Bed dimensions:') }</dt>
                            <dd>
                                { `${mca_l_letto_utile} x ${mca_p_letto_utile}cm` }
                            </dd>
                            </>
                        ) }

                        { mca_p_aperto && mca_p_aperto !== '0' && (
                            <>
                            <dt>{ __('Depth open:') }</dt>
                            <dd>{ mca_p_aperto }</dd>
                            </>
                        ) }
                    </dl>
                </div>

                { mc_measure_image && (
                    <div className="col-sm-12  mcTechspecs-Content">
                        <img className="measure-image" src={ mc_measure_image } alt="" />
                    </div>
                ) }
            </div>
        );
    }

    renderMcBoxCount() {
        const {
            mcTechSpecs: {
                mc_box_count,
                mc_box_sizes,
            },
        } = this.props;

        return (
            <div className="misure_confezione">
                <h3 className="mcTechspecs-Subtitle">{ __('Pack sizes') }</h3>
                <div>
                    <span className="mcTechspecs-Sectiontitle">{ __('Packages: ') }</span>
                    { mc_box_count
                    && (
                        <span className="mcTechspecs-Sectiontitle">{ mc_box_count }</span>
                    ) }

                    <dl>
                        { mc_box_sizes && mc_box_sizes.map((item, i) => (
                            <div>
                                <dt>{ __('Size %s:', i + 1) }</dt>
                                <dd>{ `${item.w} x ${item.h} x ${item.p} ` }</dd>
                            </div>
                        )) }
                    </dl>
                </div>
            </div>
        );
    }

    renderGetId(url) {
        const length = 11;
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === length)
            ? match[2]
            : null;
    }

    getVideo(assemblyVideo) {
        const { showEntityPopup } = this.props;
        const srcIframe = `https://www.youtube.com/embed/${this.renderGetId(assemblyVideo)}?version=3&loop=1`;

        return (
                <div>
                    <button
                      className="assembly"
                      onClick={ () => {
                          showEntityPopup('video-popup');
                      } }
                    >
                        { __('GUARDA COME MONTARLO') }
                        <i className="fa fa-play-circle" aria-hidden="true" />
                    </button>
                            <Popup
                              id="ENTITY_POPUP_video-popup"
                              customClass="assemblyPopup"
                            >
                            <div>
                                <div
                                  className=""
                                >
                                    <div block="ProductGallery" elem="VideoBackupImage2">
                                        <iframe
                                          src={ srcIframe }
                                          title="YouTube video player"
                                          allow="accelerometer; autoplay; clipboard-write;
                                      encrypted-media; gyroscope; picture-in-picture"
                                        />
                                    </div>
                                </div>
                            </div>
                            </Popup>
                </div>
        );
    }

    renderProdottoMisureTab() {
        const {
            mcTechSpecs: {
                mc_features, mc_to_mount, mc_maintenance, mc_pdf_manuals, mc_box_count,
            },
            product: {
                video_assembly,
                descrizione_completa,
            },
        } = this.props;

        return (
            <div id="instructions" className="single_tab">
                { descrizione_completa && (
                    <div className="description">
                        <h3>{ __('Descrizione completa') }</h3>
                        <p>{ descrizione_completa }</p>
                    </div>
                ) }
                <div className="features">
                    { mc_features && (
                        <>
                            <h3>{ __('Characteristics') }</h3>
                            <p>{ parse(mc_features) }</p>
                        </>
                    ) }
                    { mc_to_mount && (
                        <p>{ __('The product must be assembled') }</p>
                    ) }
                </div>
                { mc_maintenance && (
                    <div className="manutenzione">
                        <h3>{ __('Maintenance') }</h3>
                        <p>{ parse(mc_maintenance) }</p>
                    </div>
                ) }
                { this.renderMeasures() }
                { mc_box_count && (
                    this.renderMcBoxCount()
                ) }
                { mc_pdf_manuals && mc_pdf_manuals.length > 0 && (
                    <div className="istruzioni">
                        <h3 className="istruzioni">{ __('Instructions') }</h3>
                        <div className="mcTechspecs-Content">
                            <dl>
                                { mc_pdf_manuals.map((item) => (
                                    <dd>
                                        <a
                                          href={ item.url }
                                          target="_blank"
                                          className="mcTechspecs-ManualePdf"
                                          rel="noreferrer"
                                        >
                                            { __(item.name) }
                                            <i className="fa fa-arrow-circle-down" />
                                        </a>
                                    </dd>
                                )) }
                            </dl>
                        </div>
                    </div>
                ) }
                { video_assembly && video_assembly !== '' && this.getVideo(video_assembly) }
            </div>
        );
    }

    renderFinitureColoriTab() {
        const { product: { mc_finiture_colori_information } } = this.props;

        const itemsToShow = 18;

        return (
            this.renderEntityTabGrid(mc_finiture_colori_information, itemsToShow, 'finiture_e_colori')
        );
    }

    renderComplementiTab() {
        const { product: { mc_complementi_information } } = this.props;

        const itemsToShow = 8;

        return (
            this.renderEntityTabGridLink(mc_complementi_information, itemsToShow, 'complementi')
        );
    }

    renderVersioniProdottoTab() {
        const { product: { mc_versioni_prodotto_information } } = this.props;

        const itemsToShow = 8;

        return (
            this.renderEntityTabGridLink(mc_versioni_prodotto_information, itemsToShow, 'versioni_prodotto')
        );
    }

    renderTabs() {
        const {
            product,
        } = this.props;

        const tabs = [
            { name: __('PRODUCT AND MEASURES'), render: this.renderProdottoMisureTab.bind(this) },
        ];

        if (product.mc_finiture_colori) {
            tabs.push({ name: __('FINISHES AND COLORS'), render: this.renderFinitureColoriTab.bind(this) });
        }

        if (product.mc_versioni_prodotto_information) {
            tabs.push({ name: __('VERSIONS'), render: this.renderVersioniProdottoTab.bind(this) });
        }

        if (product.mc_complementi) {
            tabs.push({ name: __('COMBINE IT WITH'), render: this.renderComplementiTab.bind(this) });
        }

        return tabs;
    }

    render() {
        return (
            <div block="ProductElementsTabs">
                <ProductTabs
                  tabs={ this.renderTabs() }
                  defaultTab={ 0 }
                />
            </div>
        );
    }
}

export default TavoliComponent;
